import {
  getOrderNewCardDetails,
  getOrderStoredCardDetails,
  getPaymentName,
} from '../PlaceOrderSelectors/PlaceOrderPropertiesSelectors';

export const getCardTrackingAttributes = (state) => {
  const paymentName = getPaymentName(state);

  if (paymentName === 'new-credit-card') {
    const newCardDetails = getOrderNewCardDetails(state);
    const cv2Value = newCardDetails?.cv2 ?? 'undefined';
    const cardNumberLength = newCardDetails?.creditCardNumber?.toString().length ?? 0;
    return [
      {name: 'cv2Value', value: cv2Value},
      {name: 'cardNumberLength', value: cardNumberLength},
    ];
  } if (paymentName === 'stored-credit-card') {
    const storedCardDetails = getOrderStoredCardDetails(state);
    const cv2ValueStored = storedCardDetails?.cv2 ?? 'undefined';
    return [
      {name: 'cv2Value', value: cv2ValueStored},
    ];
  }
  return [];
};
